/* eslint-disable no-unused-vars */
import React from 'react';
import {useHistory} from 'react-router-dom';
let history;
function History()
{
    history=useHistory();
    return (
        <>
        
        </>
    )
}
export default History;
export {history}